export default __webpack_public_path__ + "static/media/parents-room.inline.19096b5e.svg";